module.exports = __webpack_public_path__ + "img/2021y_top1_jy.d1727886.jpg";